"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.usePriceTerms = void 0;
var TileDataContext_1 = require("../components/TileDataContext");
var react_1 = require("react");
var usePriceTerms = function () {
    var financeInfo = (0, TileDataContext_1.useTileDataContext)().financeInfo;
    return (0, react_1.useMemo)(function () {
        var _a = financeInfo.price || {}, _b = _a.monthlyPayment, monthlyPayment = _b === void 0 ? undefined : _b, _c = _a.downPayment, downPayment = _c === void 0 ? undefined : _c, _d = _a.downPaymentDetails, downPaymentDetails = _d === void 0 ? undefined : _d, _e = _a.apr, apr = _e === void 0 ? undefined : _e, _f = _a.termInMonths, termInMonths = _f === void 0 ? undefined : _f;
        var hasTerms = monthlyPayment != null &&
            downPayment != null &&
            apr != null &&
            termInMonths != null;
        var totalCashDue = (downPaymentDetails === null || downPaymentDetails === void 0 ? void 0 : downPaymentDetails.totalCashDue) || undefined;
        return {
            monthlyPayment: monthlyPayment,
            downPayment: downPayment,
            apr: apr,
            termInMonths: termInMonths,
            totalCashDue: totalCashDue,
            hasTerms: hasTerms
        };
    }, [financeInfo.price]);
};
exports.usePriceTerms = usePriceTerms;
//# sourceMappingURL=usePriceTerms.js.map